<template>
  <div>
    <list
      row-key="PurchaseArrivalId"
      ref="list"
      unit="应付总账"
      :page="page"
      :queryParamsAppend="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :delete-func="api.delete"
      :get-data-func="getDataFunc"
      :summary-method="summaryFunc"
      :show-summary="summaryShow"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="对账期间" label-width="100px">
          <el-date-picker
            @change="monthrangeChange"
            v-model="value"
            value-format="yyyy-MM-dd"
            style="width: 180px"
            type="monthrange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="对账周期" label-width="100px">
          <el-select v-model="params.Cycle" @change="cycleChange" clearable>
            <el-option value="今天"></el-option>
            <el-option value="昨天"></el-option>
            <el-option value="近3天"></el-option>
            <el-option value="近7天"></el-option>
            <el-option value="近14天"></el-option>
            <el-option value="本周"></el-option>
            <el-option value="上周"></el-option>
            <el-option value="本月"></el-option>
            <el-option value="上月"></el-option>
            <el-option value="本季"></el-option>
            <el-option value="上季"></el-option>
            <el-option value="本年"></el-option>
            <el-option value="上年"></el-option>
          </el-select>
        </el-form-item>
      </template>
    </list>
    <list-dialog ref="listDialog" />
  </div>
</template>
<script>
import listMixin from '@/mixins/trend/list'
import list from '@/components/common/trendsTable/list'
import listDialog from '@/components/finance/dealings/inledgerdts/listDialog'
import tableColumn from '@/data/finance/dealings/outledger/list.json'
import tableParam from '@/data/finance/dealings/outledger/query.json'
// import supplier from "@/components/purchase/supplier/listDialog";

export default {
  mixins: [listMixin],
  components: {
    list,
    listDialog
    // supplier
  },
  provide() {
    return {
      IsDefaultMonth: false
    }
  },
  data() {
    return {
      api: require('@/api/rp/rpPayDoc').default,
      value: [],
      params: {
        DocDateStart: null,
        DocDateEnd: null
      },
      isMB: this.$store.state.isMB,
      summaryShow: false,
      total: null
    }
  },
  mounted() {
    if (!this.$permission.canPrice('/finance/dealings/outledger')) {
      const findIndex = this.$refs.list.tableList.findIndex(item => item.tableName == 'PreviousBalance')
      if (findIndex >= 0) this.$refs.list.tableList.splice(findIndex, 1)
      const findIndex1 = this.$refs.list.tableList.findIndex(item => item.tableName == 'CurrentIncome')
      if (findIndex1 >= 0) this.$refs.list.tableList.splice(findIndex1, 1)
      const findIndex2 = this.$refs.list.tableList.findIndex(item => item.tableName == 'CurrentPay')
      if (findIndex2 >= 0) this.$refs.list.tableList.splice(findIndex2, 1)
      const findIndex3 = this.$refs.list.tableList.findIndex(item => item.tableName == 'CurrentBalance')
      if (findIndex3 >= 0) this.$refs.list.tableList.splice(findIndex3, 1)
    }
  },
  computed: {
    date() {
      return [this.params.MonthStart, this.params.MonthEnd]
    },
    sDate() {
      return this.$dayjs().endOf('month').format('YYYY-MM-DD')
    },
    eDate() {
      return this.$dayjs().subtract(3, 'month').startOf('month').format('YYYY-MM-DD')
    }
  },

  methods: {
    onExport() {
      var list = this.$refs.list
      var listParams = list.tempQueryParams
      var fields = list.tableList.map(x => x.tableName)
      var params = { ...listParams, Fields: fields.join(',') }
      // console.log('onExport', params);
      var loading = this.$loading({
        lock: true,
        text: '正在导出...',
        spinner: 'el-icon-loading',
        customClass: 'my_loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })
      this.api.getRpPayPaySumExport(params).then(res => {
        loading.close()
      })
    },
    monthrangeChange(t) {
      this.params.DocDateStart = t[0]
      var str = t[1].slice(5, 7)
      var year = t[1].slice(0, 4)
      var lastDate = new Date(year, str, 0).getDate()
      this.params.DocDateEnd = year + '-' + str + '-' + lastDate
    },
    getDataFunc(params) {
      console.log(params, 'params')
      return new Promise((resolve, reject) => {
        // if (!params.DocDateStart) params.DocDateStart = params.MonthStart;
        // if (!params.DocDateEnd) params.DocDateEnd = params.MonthEnd;
        if (params.DocDateStart === null) params.DocDateStart = this.sDate
        if (params.DocDateEnd === null) params.DocDateEnd = this.eDate

        if (!params.DocDateStart || !params.DocDateEnd) {
          this.$message.warning('请选择对账日期或对账期间')
          resolve({ Data: [] })
        } else {
          this.api.getRpPayPaySum(params).then(res => {
            let times = Math.ceil(res.Count / params.pageSize)
            //判断是否最后一页
            if (times == params.pageIndex) {
              this.api.getRpPayPaySumTotal(params).then(res => {
                console.log('total', res)
                if (res.Code == 0 && res.Data) {
                  this.total = res.Data[0]
                  this.summaryShow = true
                } else {
                  this.summaryShow = false
                }
              })
            } else {
              this.summaryShow = false
            }
            resolve(res)
          })
        }
      })
    },
    // openTradeunit() {
    //   this.$refs.supplier.open().then((that) => {
    //     that.getData();
    //   });
    // },
    setTradeunit(data) {
      this.params.TradeUnitId = data.TradeUnitId
      this.params.TradeUnitName = data.FullName
    },
    dateChange(val) {
      this.params.DocDateStart = val.Start
      this.params.DocDateEnd = val.End
    },
    monthChange(val) {
      this.params.MonthStart = val.Start
      this.params.MonthEnd = val.End
    },
    onClick(row) {
      console.log('打开明细列表')
      this.$refs.listDialog.open().then(that => {
        var params = {
          TradeUnitId: row.TradeUnitId,
          TradeUnitName: row.TradeUnitName,
          DocDateStart: this.params.DocDateStart,
          DocDateEnd: this.params.DocDateEnd
        }
        that.query(params)
      })
    },
    cycleChange(t) {
      var today = this.$commonJs.getToday()
      var start = ''
      var end = ''
      switch (t) {
        case '今天':
          start = today
          end = today
          break
        case '昨天':
          start = this.$dayjs().subtract(1, 'day').format('YYYY-MM-DD')
          end = start
          break
        case '近3天':
          start = this.$dayjs().subtract(2, 'day').format('YYYY-MM-DD')
          end = today
          break
        case '近7天':
          start = this.$dayjs().subtract(6, 'day').format('YYYY-MM-DD')
          end = today
          break
        case '近14天':
          start = this.$dayjs().subtract(13, 'day').format('YYYY-MM-DD')
          end = today
          break
        case '本周':
          start = this.$dayjs().startOf('week').format('YYYY-MM-DD')
          end = today
          break
        case '上周':
          var week = this.$dayjs().subtract(1, 'week')
          start = week.startOf('week').format('YYYY-MM-DD')
          end = week.endOf('week').format('YYYY-MM-DD')
          break
        case '本月':
          start = this.$dayjs().startOf('month').format('YYYY-MM-DD')
          end = today
          break
        case '上月':
          var month = this.$dayjs().subtract(1, 'month')
          start = month.startOf('month').format('YYYY-MM-DD')
          end = month.endOf('month').format('YYYY-MM-DD')
          break
        case '本季':
          start = this.$dayjs().startOf('quarter').format('YYYY-MM-DD')
          end = today
          break
        case '上季':
          var quarter = this.$dayjs().subtract(1, 'quarter')
          start = quarter.startOf('quarter').format('YYYY-MM-DD')
          end = quarter.endOf('quarter').format('YYYY-MM-DD')
          break
        case '本年':
          start = this.$dayjs().startOf('year').format('YYYY-MM-DD')
          end = today
          break
        case '上年':
          var year = this.$dayjs().subtract(1, 'year')
          start = year.startOf('year').format('YYYY-MM-DD')
          end = year.endOf('year').format('YYYY-MM-DD')
          break
      }
      this.params.DocDateStart = start
      this.params.DocDateEnd = end
      this.query()
    },
    summaryFunc(param) {
      const { columns, data } = param
      var fields = ['PreviousBalance', 'CurrentIncome', 'CurrentPay', 'CurrentBalance'] //需要合计的字段
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        var field = fields.find(x => x == column.property)
        if (field) {
          sums[index] = ''
          if (this.total) {
            sums[index] = this.total[field].toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          }
        } else {
          sums[index] = ''
        }
      })
      return sums
    }
  }
}
</script>
